import type { ReactElement } from 'react';
import type { MCPServerListItem } from '@kirin/api-client/contracts/mcp';
import { Badge } from '@/components/ui/badge';

/**
 * Badge next to the server name (KIR-4482 A3 / mockup 3): red "Blocked" for a
 * server blocked from Inventory, otherwise blue "New" while the server is New.
 * Blocking counts as review, so a server is never both. Endpoint rows only: a
 * gateway row's decision is shown by its Gateway Control column.
 */
export function McpServerStatusBadge({
  row,
}: {
  row: MCPServerListItem;
}): ReactElement | null {
  if (row.provenance === 'gateway') return null;
  if (row.blocked) {
    return (
      <Badge
        variant="outline"
        className="shrink-0 border-red-200 bg-red-50 text-red-700 dark:border-red-900 dark:bg-red-950 dark:text-red-300"
      >
        Blocked
      </Badge>
    );
  }
  if (row.isNew) {
    return (
      <Badge
        variant="outline"
        className="shrink-0 border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-300"
      >
        New
      </Badge>
    );
  }
  return null;
}
